import { supabase } from '../../../../shared/supabase/supabaseClient';

export const STOCK_NO_SALES_DAYS_DEFAULT = 30;

export type ProductsWithoutSalesResult = {
  days: number;
  count: number;
  productIds: string[];
};

/**
 * Productos con stock > 0 y sin venta no anulada en los últimos N días.
 * Fuente: RPC `inventory_branch_products_without_sales` (no lastSaleAt de catálogo).
 */
export async function fetchProductsWithoutSales(
  branchId: string,
  days: number = STOCK_NO_SALES_DAYS_DEFAULT,
): Promise<ProductsWithoutSalesResult | null> {
  const safeBranch = branchId.trim();
  if (!safeBranch) return null;
  const safeDays = Math.max(1, Math.min(Math.floor(days) || STOCK_NO_SALES_DAYS_DEFAULT, 365));

  const { data, error } = await supabase.rpc('inventory_branch_products_without_sales', {
    p_branch_id: safeBranch,
    p_days: safeDays,
  });

  if (error) {
    console.warn('[inventory] inventory_branch_products_without_sales', error.message);
    return null;
  }
  if (!data || typeof data !== 'object') return null;

  const j = data as Record<string, unknown>;
  const rawIds = j.product_ids;
  const productIds: string[] = [];
  if (Array.isArray(rawIds)) {
    for (const id of rawIds) {
      if (typeof id === 'string' && id.trim()) productIds.push(id.trim());
    }
  }

  return {
    days: Number(j.days ?? safeDays) || safeDays,
    count: Number(j.count ?? 0) || 0,
    productIds,
  };
}
